export default "__VITE_ASSET__Dvzx4H_O__"